import { render, staticRenderFns } from "./MomentActivityListComponent.vue?vue&type=template&id=4729065e&scoped=true&"
import script from "./MomentActivityListComponent.vue?vue&type=script&lang=ts&"
export * from "./MomentActivityListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MomentActivityListComponent.vue?vue&type=style&index=0&id=4729065e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4729065e",
  null
  
)

export default component.exports